module.exports = __webpack_public_path__ + "static/Adan-0355d70ef639b31c299e2c6d3f3a6d94.jpg";